import React, { Ref } from 'react';
import ModalTableMultiselect, {
  TableMultiselect,
  TableMultiselectHandle,
  TableMultiselectProps,
} from '@lib/components/ModalTableMultiselect/ModalTableMultiselect';
import { BaseItem } from '@lib/components/Table/types';

type Props<T extends BaseItem> = {
  tableProps: Omit<TableMultiselectProps<T>, 'ref' | 'onSelectionConfirmed'>;
  // Renders the bare picker body for a host that owns the modal chrome.
  inline?: boolean;
  ref?: Ref<TableMultiselectHandle>;
  onSelectionConfirmed?: () => void;
  caption: string;
  renderAfterCaption?: React.ReactNode;
  onClose: () => void;
};

// The Tasks / Task completions pickers render either inline (one step of a
// host wizard) or as their own full-screen modal; only the wrapper differs.
export default function TaskPickerTable<T extends BaseItem>({
  tableProps,
  inline,
  ref,
  onSelectionConfirmed,
  caption,
  renderAfterCaption,
  onClose,
}: Props<T>) {
  if (inline) {
    return (
      <TableMultiselect<T>
        {...tableProps}
        ref={ref}
        onSelectionConfirmed={onSelectionConfirmed}
      />
    );
  }
  return (
    <ModalTableMultiselect<T>
      {...tableProps}
      caption={caption}
      renderAfterCaption={renderAfterCaption}
      onClose={onClose}
    />
  );
}
